"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("../Observable/Observable");
var ConfigStore = /** @class */ (function () {
    function ConfigStore() {
        this.name = '';
        this.model = null;
        this.actions = null;
        this.observable = Observable_1.default;
        this.links = [];
        Object.seal(this);
    }
    Object.defineProperty(ConfigStore.prototype, "observableArity", {
        get: function () {
            return this.observable.length;
        },
        enumerable: false,
        configurable: true
    });
    return ConfigStore;
}());
exports.default = ConfigStore;
//# sourceMappingURL=ConfigStore.js.map